module.exports = __webpack_public_path__ + "img/_hand.39b04647.png";